import { App } from '@capacitor/app'
import type { Router } from 'vue-router'
import { clearAuthToken } from '../services/authToken'

const AUTO_LOGOUT_DELAY_MS = 20_000

let logoutTimer: ReturnType<typeof setTimeout> | null = null

function clearLogoutTimer(): void {
  if (logoutTimer) {
    clearTimeout(logoutTimer)
    logoutTimer = null
  }
}

async function doLogout(router: Router): Promise<void> {
  await clearAuthToken()

  if (router.currentRoute.value.name !== 'login') {
    await router.replace({ name: 'login' })
  }
}

export function setupAutoLogout(router: Router): void {
  App.addListener('appStateChange', ({ isActive }) => {
    if (isActive) {
      clearLogoutTimer()
      return
    }

    clearLogoutTimer()

    logoutTimer = setTimeout(() => {
      void doLogout(router)
    }, AUTO_LOGOUT_DELAY_MS)
  })

  App.addListener('pause', () => {
    clearLogoutTimer()
    logoutTimer = setTimeout(() => {
      void doLogout(router)
    }, AUTO_LOGOUT_DELAY_MS)
  })

  App.addListener('resume', () => {
    clearLogoutTimer()
  })
}
